import hotelRoomAllocations from './hotelRoomAllocations.js'
import times from 'lowscore/times.js'
import sortBy from 'lowscore/sortBy.js'
import roomAllocationsEqual from '../roomAllocationsEqual.js'
import find from 'lowscore/find.js'
import ValidationError from '../../../services/web/server/public-api/validationError.js'
import toOldHotelFormat from './toOldHotelFormat.js'

export default class Hotels {
  constructor (options) {
    this.departure = options.departure
    this.beforeAfter = options.beforeAfter
    const hotels = (this.beforeAfter == 'before'
      ? this.departure.hotels.beforeTour
      : this.departure.hotels.afterTour).map(toOldHotelFormat)
    const preferredHotels = (this.departure.preferredHotels || {})[`${this.beforeAfter}Tour`] || []
    const preferredHotelMatches = hotels.filter(hotel => preferredHotels.includes(hotel.code))
    this.hotels = preferredHotelMatches.length > 0 ? preferredHotelMatches : hotels
    this.hotelAvailabilitiesByCode = {}
    this.preferredRooms = {}
    this.chosenHotel = {}
    this.computeAllNights()
    this.loaded = false
    this.features = options.features
  }

  computeAllNights () {
    const maxNightsAvailable = this.computeMaxNightsAvailable()

    const roomAllocationsForHotel = (hotel, days) => {
      return this.partyForAllocation ? hotelRoomAllocations(hotel, days, this.partyForAllocation, this.features) : []
    }

    const hotelRoomPreferrences = this.hotels.reduce((acc, hotel) => ({...acc, [hotel.id]: {}}), {})

    this.nights = times(maxNightsAvailable + 1, nights => {
      if (nights) {
        const days = this.dates(nights)
        const hotels = sortBy(
          this.hotels
            .map(hotel => {
              const roomAllocations = roomAllocationsForHotel(hotel, days)

              if (
                this.isHotelAvailableAllDays(hotel, days) &&
                roomAllocations.length > 0
              ) {
                return new Hotel(
                  hotel,
                  roomAllocations,
                  this.preferredRooms,
                  hotelRoomPreferrences[hotel.id]
                )
              }
            })
            .filter(h => h),
          h => {
            return h.roomAllocations()[0].price
          }
        )

        return new NightRange(nights, hotels, this.chosenHotel)
      } else {
        return new NightRange(0, [], this.chosenHotel)
      }
    }).filter(n => n.number === 0 || n.hotels.length > 0)

    this.selectedNights = this.nights[0]
  }

  hasSelectedHotels () {
    return this.selectedNights ? this.selectedNights.number > 0 : false
  }

  computeMaxNightsAvailable () {
    if (this.hotels.length) {
      var numberOfDaysToConsider = Math.max.apply(
        Math,
        this.hotels.map(h => h.days.length)
      )

      var areNoHotelsAvailableForDate = date => {
        return this.hotels.every(hotel => {
          return !this.isHotelAvailableForDate(hotel, date)
        })
      }

      const indexOfFirstUnavailability = (this.dates(numberOfDaysToConsider) || [])
        .findIndex(areNoHotelsAvailableForDate)

      return indexOfFirstUnavailability == -1
        ? numberOfDaysToConsider
        : indexOfFirstUnavailability
    } else {
      return 0
    }
  }

  setUrlParams (params) {
    if (this.loaded) {
      const nights = (this.selectedNights = findOrFirst(
        this.nights,
        n => n.number == params.nights
      ))


      const hotel = nights.selectHotel(
        find(nights.hotels, h => (this.beforeAfter === 'before' && (h.preId == params.hotelId || h.id == params.hotelId)) ||
                                 (this.beforeAfter === 'after' && (h.postId == params.hotelId || h.id == params.hotelId))
        )
      )
      if (!hotel) {
        throw new ValidationError([{
          message: 'Your requested extra nights are not available in your requested hotel',
          property: 'extraNightHotels',
        }])
      }

      const roomAllocations = params.rooms
        ? findRoomAllocation(hotel.roomAllocations(), params.rooms)
        : findRoomAllocationOrFirst(hotel.roomAllocations(), params.rooms)

      if (!roomAllocations) {
        throw new ValidationError([{
          message: 'Your party cannot be accommodated in the chosen extra night hotel rooms',
          property: 'extraNightHotels',
        }])
      }

      hotel.selectRoomAllocation(roomAllocations)
    } else {
      this.params = params
    }
  }

  getUrlParams () {
    var nights, hotel, roomAllocation
    nights = this.selectedNights
    if (nights) {
      hotel = nights.selectedHotel()
      if (hotel) {
        roomAllocation = hotel.selectedRoomAllocation()
        return {
          nights: nights.number,
          hotelId: hotel.id,
          rooms: roomAllocation.rooms.map(r => {
            return {
              roomType: r.roomType,
              count: r.count,
            }
          }),
        }
      }
    }
  }

  selectedHotel () {
    var nights = this.selectedNights
    if (nights) {
      return nights.selectedHotel()
    }
  }

  selectedRoomAllocation () {
    var hotel = this.selectedHotel()
    if (hotel) {
      return hotel.selectedRoomAllocation()
    }
  }

  setPreferredRooms (preferredRooms) {
    this.preferredRooms.rooms = preferredRooms
  }

  setParty (party, partyForAllocation) {
    this.party = party
    this.partyForAllocation = partyForAllocation
    this.computeAllNights()
  }

  hotelsNowHaveAvailabilities () {
    this.hotelAvailabilitiesByCode = {}

    const isHotelAvailable = (availability, prePost) => {
      return availability.dayNumber === prePost && (!this.features?.hideHotelsOnRequest || availability.status !== 'onRequest')
    }

    this.hotels.forEach(hotel => {
      var days = index(hotel.days.map(d => d.date))
      this.hotelAvailabilitiesByCode[hotel.code] = index(
        hotel.availability
          .filter((availability) => {
            const isBefore = this.beforeAfter === 'before'
            return isBefore ? isHotelAvailable(availability, 'PRE') : isHotelAvailable(availability, 'POST')
          })
          .map((d)=>  d.date.toString())
          .filter(date => days[date])
      )
    })

    this.computeAllNights()

    this.loaded = true

    if (this.params) {
      this.setUrlParams(this.params)
      delete this.params
    }
  }

  hotelHasRoomsAvailable (hotel) {
    var roomsAvailable = this.roomAllocationsForHotelId(hotel.id)
    if (roomsAvailable) {
      return roomsAvailable.length > 0
    } else {
      return false
    }
  }

  hasAvailability () {
    return this.nights.length > 1
  }

  clear () {
    this.computeAllNights()
  }

  isHotelAvailableAllDays (hotel, days) {
    var availabilities = this.hotelAvailabilities(hotel)
    return days.every(d => availabilities[d])
  }

  hotelAvailabilities (hotel) {
    return this.hotelAvailabilitiesByCode[hotel.code] || {}
  }

  isHotelAvailableForDate (hotel, date) {
    return this.hotelAvailabilities(hotel)[date]
  }

  dates (nights) {
    if (this.beforeAfter == 'before') {
      return times(nights, n =>
        this.departure.startDate.addDays(-(n + 1))
      ).map(date => date.toString())
    } else {
      return times(nights, n => this.departure.endDate.addDays(n)).map(date =>
        date.toString()
      )
    }
  }
}

function findOrFirst (array, predicate) {
  return find(array, predicate) || array[0]
}

function findRoomAllocation (roomAllocations, preferredRooms) {
  return roomAllocations.find(r => {
    return roomAllocationsEqual(r.rooms, preferredRooms)
  })
}

function findRoomAllocationOrFirst (roomAllocations, preferredRooms) {
  return findOrFirst(roomAllocations, r => {
    if (preferredRooms) {
      return roomAllocationsEqual(r.rooms, preferredRooms)
    }
  })
}

function findRoomAllocationOrAll (roomAllocations, preferredRooms) {
  var found = find(roomAllocations, r => {
    if (preferredRooms) {
      return roomAllocationsEqual(r.rooms, preferredRooms)
    }
  })

  return found ? [found] : roomAllocations
}

function index (array) {
  return array.reduce((acc, value) => ({...acc, [value]: true}), {})
}

class NightRange {
  constructor (nights, hotels, chosenHotel) {
    this.number = nights
    this.hotels = hotels
    this.chosenHotel = chosenHotel
  }

  selectedHotel () {
    return (
      find(this.hotels, h => h.id == this.chosenHotel.hotelId) ||
      this.hotels[0]
    )
  }

  selectHotel (hotel) {
    if (hotel) {
      this.chosenHotel.hotelId = hotel.id
      return this.selectedHotel()
    }
  }
}

class Hotel {
  constructor (hotel, roomAllocations, preferredRooms, preferredHotelRooms) {
    this.name = hotel.name
    this.id = hotel.id
    this.associatedProductId = hotel.associatedProductId
    this.code = hotel.code
    this.preId = hotel.preId
    this.postId = hotel.postId
    this.brochureCode = hotel.brochureCode
    this.typeCode = hotel.typeCode
    this._roomAllocations = roomAllocations
    this.preferredRooms = preferredRooms
    this.preferredHotelRooms = preferredHotelRooms
  }

  roomAllocations () {
    return findRoomAllocationOrAll(
      this._roomAllocations,
      this.preferredRooms.rooms
    )
  }

  selectRoomAllocation (roomAllocation) {
    this._selectedRoomAllocation = roomAllocation
    this.preferredHotelRooms.rooms = roomAllocation.rooms
  }

  selectedRoomAllocation () {
    if (this._selectedRoomAllocation) {
      return this._selectedRoomAllocation
    } else if (this.preferredHotelRooms.rooms) {
      return findRoomAllocation(
        this._roomAllocations,
        this.preferredHotelRooms.rooms
      )
    } else if (this.preferredRooms.rooms) {
      return findRoomAllocationOrFirst(
        this._roomAllocations,
        this.preferredRooms.rooms
      )
    } else {
      return this.roomAllocations()[0]
    }
  }
}
